/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useLayoutEffect, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { postFile, get, patch } from 'lib/request';
import { getLocale } from 'lib/i18n';
import { titleize, submit } from 'lib/utility';
import ModalStore from 'lib/stores/modalStore';
import ConfigStore from 'lib/stores/configStore';
import FormStore, { handleChange } from 'lib/stores/formStore';
import Form from 'lib/components/Form';
import Progress from 'lib/components/Progress';

const PhotoForm = ({ form, onAfterSubmit, subject, editingPhoto }) => {
  const { data: { photo } } = ModalStore.useState(state => state.photoModal);
  const { photo: image = {} } = FormStore.useState(state => state);
  const { photoKinds = [] } = ConfigStore.currentState;

  const uploadPhoto = async () => {
    const data = new FormData();

    data.append('image', image.image);
    data.append('name', image.name);
    data.append('kind', image.kind);

    await postFile(`/${subject}/photos`, data);
  };

  const editPhoto = async () => {
    await patch(`/${subject}/photos/${photo.id}`, image);
  };

  const onSubmit = async e => {
    e.preventDefault();

    submit(async () => {
      if (editingPhoto) {
        await editPhoto();
      } else {
        await uploadPhoto();
      }

      const response = await get(`/${subject}/photos.json`);

      FormStore.update(state => { state.photos = response.data; });

      if (onAfterSubmit) await onAfterSubmit();
    }, 'Uploading');
  };

  useLayoutEffect(() => {
    FormStore.update(state => { state.photo = { name: '', kind: '' }; });
  }, []);

  useEffect(() => {
    if (!editingPhoto) return;

    FormStore.update(state => {
      state.photo.name = photo.name;
      state.photo.kind = photo.kind;
    });
  }, [photo]);

  return (
    <form id="photoForm" onSubmit={onSubmit}>
      {!editingPhoto && (
        <div className="mb-3">
          <Form.ImageUploader
            name="photo.image"
          />
        </div>
      )}
      <div className="mb-3">
        <label htmlFor="photoTitle" className="form-label">Optional Photo Caption</label>
        <input
          className="form-control"
          id="photoTitle"
          name="photo.name"
          data-testid="photoTitle"
          placeholder="(Optional)"
          onChange={handleChange}
          value={image.name}
        />
      </div>
      <label className="my-1 me-2" htmlFor="photoKind">* Kind</label>
      <select
        className="form-select"
        id="photoKind"
        name="photo.kind"
        aria-label="Photo Kind"
        value={image.kind}
        data-testid="photoKind"
        onChange={handleChange}
        required
      >
        <option value="">Select...</option>
        {photoKinds.map(photoKind => (
          <FormattedMessage
            key={photoKind}
            {...getLocale(form, 'suggestions', photoKind, titleize(photoKind))}
          >
            {message => <option value={photoKind}>{message}</option>}
          </FormattedMessage>
        ))}
      </select>
      {!editingPhoto && (
        <Progress />
      )}
    </form>
  );
};

export default PhotoForm;
